import React from 'react';
import { HiLightBulb, HiCommandLine, HiRocketLaunch } from 'react-icons/hi2';
import '../../styles/processDiagram.css';

const phases = [
  {
    id: 'discovery',
    number: '01',
    title: 'Discovery',
    subtitle: 'Define the vision',
    icon: HiLightBulb,
    items: ['Branding', 'Scoping', 'Information architecture', 'Prototyping', 'Design direction'],
    milestone: 'Workshop with client',
    accent: '#2563eb',
  },
  {
    id: 'build',
    number: '02',
    title: 'Build',
    subtitle: 'Ship with precision',
    icon: HiCommandLine,
    items: ['Design', 'Front-end', 'Back-end', 'Testing', 'DevOps', 'Copy & SEO'],
    milestone: 'Build kick-off',
    accent: '#0891b2',
  },
  {
    id: 'launch',
    number: '03',
    title: 'Launch & grow',
    subtitle: 'Support beyond release',
    icon: HiRocketLaunch,
    items: ['Server monitoring', 'Backups', 'Incident resolution'],
    milestone: 'Launch',
    highlight: true,
    accent: '#7c3aed',
  },
];

const ProcessDiagram = () => {
  return (
    <div className="process-flow">
      <div className="process-flow__timeline" aria-hidden="true">
        <div className="process-flow__line" />
        {phases.map((phase, index) => (
          <div key={phase.id} className="process-flow__marker" style={{ '--i': index }}>
            <span className="process-flow__marker-dot" style={{ '--accent': phase.accent }} />
          </div>
        ))}
      </div>

      <div className="process-flow__grid">
        {phases.map((phase) => {
          const Icon = phase.icon;
          return (
            <article
              key={phase.id}
              className={`process-card${phase.highlight ? ' process-card--highlight' : ''}`}
              style={{ '--accent': phase.accent }}
            >
              <div className="process-card__header">
                <div className="process-card__icon-wrap">
                  <Icon aria-hidden="true" />
                </div>
                <div>
                  <span className="process-card__number">{phase.number}</span>
                  <h3 className="process-card__title">{phase.title}</h3>
                  <p className="process-card__subtitle">{phase.subtitle}</p>
                </div>
              </div>

              <div className="process-card__tags">
                {phase.items.map((item) => (
                  <span key={item} className="process-card__tag">
                    {item}
                  </span>
                ))}
              </div>

              <div className={`process-card__milestone${phase.highlight ? ' process-card__milestone--launch' : ''}`}>
                {phase.milestone}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default ProcessDiagram;
